import { useQuery } from '@tanstack/react-query';

import { auth } from '../api/client';

/**
 * Session chip. Two outcomes:
 *  - `authDisabled` -> nothing rendered: local dev has no login to show.
 *  - authenticated  -> the avatar initial + e-mail + a Log out button.
 *
 * Logout POSTs `/auth/logout`, then a full-page load to `/login` re-mounts
 * the SPA signed-out (never back into the login POST itself — the silent
 * re-login trap is a documented boilerplate gotcha).
 */
export function UserChip() {
  const me = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: ({ signal }) => auth.me(signal),
    staleTime: 60_000,
    retry: false,
  });

  const user = me.data?.user;
  if (me.data?.authDisabled || !user) return null;

  const initial = user.name[0]?.toUpperCase() ?? user.email[0]?.toUpperCase() ?? '?';

  return (
    <div className="user" title={user.email} data-testid="user-chip">
      <span className="user__avatar" aria-hidden="true">
        {initial}
      </span>
      <span className="user__meta">
        <span className="user__email">{user.email}</span>
      </span>
      <button type="button" className="user__logout" onClick={() => void auth.logout()} aria-label="Выйти" title="Выйти">
        Выйти
      </button>
    </div>
  );
}
